import { ReactComponent as SVG_POSTTEST } from '../../../../assets/newAssets/Property 1=rpostTest.svg';
import { FileUploader } from 'react-drag-drop-files';
import { QueryInfo } from '../Brief/Brief';
import { IconContainer } from './ReportsLinks';
import { useCampaignContext } from 'context/CampaignContext';
import { useContext } from 'react';
import { saveFiletoS3 } from '../Brief/UploadFile/saveFiletoS3';
import { useLoggingActivity } from 'customHooks/useLogging';
import { fileTypes } from 'components/Main/Gallery/ARContainer';
import APIContext from 'context/APIContext';

type Props = {
  uploadedFiles: QueryInfo[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<QueryInfo[]>>;
};

const DocumentUploader = (props: Props) => {
  const { uploadedFiles, setUploadedFiles } = props;
  const { activeCampaign } = useCampaignContext();
  const { getEnvironment } = useContext(APIContext);
  const logActivity = useLoggingActivity();

  const selectedFiles = uploadedFiles;

  const addFile = async (files: File) => {
    if (files) {
      if (activeCampaign) {
        const position = 'Summary';
        const saved = saveFiletoS3(
          files,
          selectedFiles.length + 1,
          activeCampaign.campaignId,
          activeCampaign.ClientCode,
          activeCampaign.ClientCountry,
          getEnvironment,
          position,
        );
        if (saved) {
          const newFile = {
            id: saved.id,
            name: files.name,
            position: position,
          };
          setUploadedFiles((prev) => [...prev, newFile]);

          // Log the file upload activity
          logActivity({
            action: 'FILE_UPLOAD_SUMMARY',
          }).catch(console.error);
        }
      }
    }
  };

  const isUserAuthoriezed = true;

  return (
    <>
      {isUserAuthoriezed && (
        <IconContainer
          style={{ position: 'absolute', right: '100px' }}
          active={true.toString()}
          className={isUserAuthoriezed ? '' : !isUserAuthoriezed && selectedFiles.length > 0 ? '' : 'IsDisabled'}
        >
          {isUserAuthoriezed && (
            <FileUploader
              className="drop_area"
              handleChange={(file: any) => {
                addFile(file);
              }}
              name="file"
              types={fileTypes}
              children={
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
                  <SVG_POSTTEST className="svg" />
                  <h2>Campaign Evaluation</h2>
                </div>
              }
            />
          )}
        </IconContainer>
      )}
    </>
  );
};

export default DocumentUploader;
